import styled from 'styled-components';

const H4 = styled.h4.attrs({
  className: `
    text-base
    font-semibold
    text-center
    text-gray-600
    
    dark:text-gray-300
  `,
})``;

export default H4;
